var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.icon,style:(_vm.hasColor ? 'color:' + _vm.hasColor : '')})}
var staticRenderFns = []

export { render, staticRenderFns }